<ng-template #grid_row_template>
  <ng-container *ngIf="uiDeptSettings && modifiedListItems.length>0">
    <div id="row-{{listItem.id}}"
         *ngFor="let listItem of modifiedListItems;let $index = index;trackBy: trackItem"
         class="grid-content-row grid-row">
      <div class="grid-col grid-item-checkbox grid-col-frozen">
        <div class="grid-itm grid-item-rowcheckbox {{listItem.timesheetWorkflowDeptColor }}">
          <label title="{{listItem.processingDeptDisplayName}}">
            <input class="checkbox-el"
                   id="checkbox-{{listItem.id}}"
                   name="checkbox-{{listItem.id}}"
                   [checked]="listItem.selected"
                   (change)="onSelectPosition($index)"
                   [disabled]="!listItem.businessValidation.canSelect"
                   type="checkbox" />
          </label>
        </div>
      </div>
      <div class="grid-col grid-col-contact grid-col-frozen">
        <div class="grid-row d-flex"  [class]="getContactClass(listItem.contact)">

          <ng-container *ngIf="!listItem.businessValidation.isContactAvailable">
            <div class="col-md-9" style="padding:0">
              <div class="grid-itm grid-itm-contact">
                <div class="grid-contact-edit">
                  <div id="firstName-validationmsg-{{listItem.id}}" class="required-msg d-none">Required</div>
                  <div class="form-inline">
                    <span [ngClass]="buAccess.department!='PAYROLL'?'droppable':''"
                          data-contact-type="primary"
                          cdkDropList
                          [cdkDropListData]="list2"
                          #temp{{listItem.id}}="cdkDropList"
                          id="list-{{listItem.id}}"
                          (cdkDropListDropped)="assignContactDnD($event,listItem.id)">
                    </span>
                    <div style="width:99%">
                      <nbc-contact-auto placeholder="Contact Name" listItemId="{{listItem.id}}">
                      </nbc-contact-auto>
                    </div>
                    <!--<input type="text" style="width:70%"
            authenticate-user="Timecard.ContactName.Update"
            authenticate-command="disabled"
            class="form-control"
            placeholder="Contact Name" />-->
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
        
          <ng-container *ngIf="listItem.businessValidation.isContactAvailable">
            <div class="col-md-2 ps-3 pe-3">
              <div>
                <div class="contact-detail-img float-start">
                  <div class="grid-itm-contact-img">
                    <span class="changed-by-text">
                      <span class="drag-glow">
                        <img src="/assets/image/contact/null"
                             class="drag-glow droppable draggable primary-contact"
                             cdkDropList
                             [cdkDropListData]="list2"
                             #temp{{listItem.id}}="cdkDropList"
                             id="list-{{listItem.id}}"
                             (cdkDropListDropped)="listItem.businessValidation.canReplace && !listItem?.parentTimecard ? assignContactDnD($event,listItem.id) : ''"
                             [class.required-outline]="mandatoryConfig.firstName"
                             (blur)="onBlurDatavalidation($index)"
                             data-contact-type="primary"
                             width=" 35"
                             height="35" />
                        <!--<img class="drag-glow droppable draggable primary-contact"
                [class.droppable]="listItem.businessValidation.canReplace && !listItem.parentTimecard"
                [class.required-outline]="mandatoryConfig.firstName"
                (blur)="onBlurDatavalidation($index)"
                data-contact-type="primary"
                src="/assets/image/contact/null"
                width=" 35"
                height="35" />-->
                      </span>
                    </span>
                  </div>
                </div>
              </div>

            </div>
          </ng-container>

          <ng-container *ngIf="listItem.businessValidation.isContactAvailable">
            <div class="col-md-6 float-start ps-3 pe-3">
              <div class="contact-detail-container" style="display:block;width:130px">
                <div>
                  <a href="/scorepay/contact/{{listItem.contact?.id ? listItem.contact.id : 0}}"
                     target="_blank"
                     title="{{listItem.contact?.firstName}}, {{listItem.contact?.lastName}}">
                    <span class="item-ttl-bld" title="{{listItem.contact?.firstName}} {{listItem.contact?.lastName}}" innerHTML="{{listItem.contact?.firstName}} {{listItem.contact?.lastName}}">
                      
                    </span>
                  </a>
                </div>
                <div class="contact-details" *ngIf="listItem.contact">
                  <div *ngIf="listItem.contact.sso">SSO:  {{listItem.contact.sso}}</div>
                  <div *ngIf="!listItem.contact.sso && listItem.contact.perNer">PerNer:  {{listItem.contact.perNer}}</div>
                  <div *ngIf="listItem.contact.subBusinessSegment"
                       class="changed-by-text">{{listItem.contact.subBusinessSegment}}</div>
                </div>
                <div>
                  <span class="reject-comment"
                        [ngClass]="{'d-none': listItem.parentTimecard || !listItem.businessValidation.showRejectAlertIcon,
                                    'reject-alert': listItem.businessValidation.showRejectAlert}"
                        [popover]="listItem.queueStatus === 'INQUEUE' ? popRejectComment : ''"
                        popoverTitle="Reject Comment"
                        triggers="mouseenter:mouseleave"
                        [outsideClick]="false">
                    <i class="fa fa-exclamation-triangle"></i>
                    <ng-template #popRejectComment>
                      <div style="padding:10px;margin:10px;width:200px">
                        {{listItem.rejectComment}}
                      </div>
                    </ng-template>
                  </span>
                </div>
              </div>
            </div>
          </ng-container>



          <div class="col-md-2 ms-auto">
            <div class="grid-col-actions-clone">
              <label class="timecard-action-button btn-clone-timecard btn"
                    authenticate-user="Timecard.Create"
                    authenticate-command="disabledlabel"
                    [ngClass]="listItem.businessValidation.canClone && !listItem.parentTimecard ?'grid-activebtn':''"
                    style="font-size:11px;display:inline-block;"
                    [authenticate-disabled]="(!listItem.businessValidation.canClone || !!listItem.parentTimecard) || null"
                    title="Clone"
                    (click)="onCloneTimecard(listItem.id)">
                <i class="fa fa-clone"></i>
              </label>
            </div>
            <div class="grid-col-actions-unlock"
                 [ngClass]="!listItem.businessValidation.canUnlock ? 'd-none':''">
              <span class="timecard-action-button btn-unlock-timecard btn"
                    [class.grid-activebtn]="listItem.businessValidation.canUnlock"
                    [class.d-none]="!listItem.businessValidation.canUnlock"
                    style="display: inline-grid;"
                    title="Unlock"
                    authenticate-user="Timecard.Unlock"
                    (click)="onUnlockTimecard(listItem.id)">
                      <i *ngIf="listItem.workflowStatus && listItem.workflowStatus?.isUnlocked" class="fa fa-unlock" aria-hidden="true"></i>
                      <i *ngIf="listItem.workflowStatus && !listItem.workflowStatus?.isUnlocked" class="fa fa-lock" aria-hidden="true"></i>
              </span>
            </div>
            <div class="grid-col-actions-delete">
              <label class="timecard-action-button btn-department-trash-timecard btn"
                    [ngClass]="listItem.businessValidation.canDelete ?'grid-activebtn':''"
                    authenticate-user="Timecard.Delete"
                    authenticate-command="disabledlabel"
                    style="display:inline-grid;"
                    [authenticate-disabled]="!listItem.businessValidation.canDelete || null"
                    title="Delete"
                    (click)="onTimecardDelete(listItem.id)">
                      <i class="fa fa-trash" aria-hidden="true"></i>
              </label>
            </div>

            <input type="hidden" id="sso-{{listItem.id}}" name="sso-{{listItem.id}}" [attr.value]="listItem.contact?.sso ? listItem.contact.sso:null" />
          </div>
        </div>
      </div>
      <ng-container *ngIf="buAccess.department === 'SUBMITTER' || hasTalentDepartment || hasFinanceDepartment || hasPayrollDepartment">

        <div [class.d-none]="uiDeptSettings.isOperationDeptExpanded"
             class="grid-col grid-col-emp-type ops-dept-collapse ops-collapsed-bar">
          <div class=" grid-itm">

          </div>
        </div>
        <ng-container>
          <div class="grid-col operation-field activity-date"
               [class.d-none]="!uiDeptSettings.isOperationDeptExpanded">
            <div class=" grid-itm">
              <div class="form-group">
                <div id="activityDate-validationmsg-{{listItem.id}}" class="required-msg d-none">Required</div>
                <div class="input-group date activity-datetimepicker">
                  <input type="text"
                         #activityDate="ngModel"
                         name="activityDate-{{listItem.id}}"
                         id="activityDate-{{listItem.id}}"
                         class="form-control activity-date-focus filter-activityDate"
                         [ngClass]="mandatoryConfig.activityDate ? 'required-outline':''"
                         ngModel
                         bsDatepicker
                         authenticate-user="Timecard.DateWorked.Update"
                         authenticate-command="disabled"
                         #drp="bsDatepicker"
                         [(ngModel)]="listItem.activityDate"
                         (ngModelChange)="onActivityDateChange($index,$event)"
                         [bsConfig]="{ isAnimated: true, dateInputFormat: 'MM/DD/YYYY', customTodayClass:'custom-today-class'}"
                         [authenticate-disabled]="(!listItem.businessValidation.isFieldEnabled || !!listItem.parentTimecard) || null" />
                  <span class="input-group-text">
                    <!--<span class="glyphicon glyphicon-calendar"></span>-->
                    <!--SCOR-22127-->
                    <i class="fa fa-calendar"></i>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div class="grid-col grid-col-scroll operation-field"
               [class.d-none]="!uiDeptSettings.isOperationDeptExpanded">
            <div id="dayType-validationmsg-{{listItem.id}}" class="required-msg d-none">Required</div>
            <div class=" grid-itm daytypes-list">
              <nbc-select [source]="daytypes"
                          authenticate-user="Timecard.DayType.Update"
                          authenticate-command="nbcselectdisabled"
                          [(model)]="listItem.dayType"
                          nbcMismatch="input-xs"
                          [title]="listItem.dayType?.description ? listItem.dayType.description:null"
                          display="description"
                          value="id"
                          name="dayType-{{listItem.id}}"
                          id="dayType-{{listItem.id}}"
                          placeHolderValue="-1"
                          placeHolderDisplay="-Select-"
                          [customErrorClass]="mandatoryConfig.dayType ? 'required-outline':''"
                          [authenticate-disabled]="!listItem.businessValidation.isFieldEnabled || listItem.parentTimecard"
                          (modelChange)="onBlurDatavalidation($index)"></nbc-select>
            </div>
          </div>
          <div class="grid-col grid-col-emp-type operation-field"
               [class.d-none]="!uiDeptSettings.isOperationDeptExpanded">
            <div class="grid-itm">
              <div id="eventShowName-validationmsg-{{listItem.id}}" class="required-msg d-none">Required</div>
              <input class="form-control required-outline event-show-name-el text-font"
                     [(ngModel)]="listItem.eventShowName"
                     [innerHtml]="listItem.eventShowName | sanitizeHtml"
                     maxlength="255"
                     type="text"
                     placeholder="Event/Show Name"
                     data-field="eventShowName"
                     authenticate-user="Timecard.EventShow.Update"
                     authenticate-command="disabled"
                     [attr.title]="listItem.eventShowName ? listItem.eventShowName :''"
                     name="eventShowName-{{listItem.id}}"
                     id="eventShowName-{{listItem.id}}"
                     (blur)="onBlurDatavalidation($index)"
                     (ngModelChange)="onEvenShowNameChange($index,$event)"
                     [authenticate-disabled]="(!listItem.businessValidation.isFieldEnabled || !!listItem.parentTimecard)||null"/>
            </div>
            <div class="grid-itm padding-top operation-field">
              <nbc-select [source]="sports"
                          [model]="listItem.sport"
                          [title]="listItem.sport?.description ? listItem.sport.description:null"
                          display="description"
                          value="id"
                          name="sport-{{listItem.id}}"
                          id="sport-{{listItem.id}}"
                          placeHolderValue="-1"
                          placeHolderDisplay="-Select-"
                          [customErrorClass]="mandatoryConfig.sport ? 'required-outline':''"
                          [nbcDisabled]="!listItem.businessValidation.isFieldEnabled|| listItem.parentTimecard"
                          authenticate-user="Timecard.EventShow.Update"
                          authenticate-command="nbcdisabled"
                          nbcMismatch="input-xs"
                          (modelChange)="onSportChange($event,$index,'sport');onBlurDatavalidation($index)"></nbc-select>
            </div>
          </div>
          <div class="grid-col grid-col-scroll operation-field"
               [class.d-none]="!uiDeptSettings.isOperationDeptExpanded">
            <div id="network-validationmsg-{{listItem.id}}" class="required-msg d-none">Required</div>
            <div class=" grid-itm networks-list">
              <nbc-select [source]="networks"
                          [(model)]="listItem.network"
                          nbcMismatch="input-xs"
                          [title]="listItem.network?.description ? listItem.network.description:null"
                          display="description"
                          value="id"
                          name="network-{{listItem.id}}"
                          id="network-{{listItem.id}}"
                          placeHolderValue="-1"
                          placeHolderDisplay="-Select-"
                          [customErrorClass]="mandatoryConfig.network ? 'required-outline':''"
                          [nbcDisabled]="!listItem.businessValidation.isFieldEnabled|| listItem.parentTimecard"
                          authenticate-user="Timecard.Network.Update"
                          authenticate-command="nbcdisabled"
                          (modelChange)="onBlurDatavalidation($index)"></nbc-select>
            </div>
          </div>
          <!--SCOR-15980 Starts-->
          <div class="grid-col grid-col-scroll operation-field"
               [class.d-none]="!uiDeptSettings.isOperationDeptExpanded">
            <div id="employeeType-validationmsg-{{listItem.id}}" class="required-msg d-none">Required</div>
            <div class=" grid-itm grid-employee-type">
              <nbc-select [source]="employeeTypes"
                          [(model)]="listItem.employeeType"
                          [title]="listItem.employeeType?.description ? listItem.employeeType.description:''"
                          display="description"
                          value="id"
                          name="employeeType-{{listItem.id}}"
                          id="employeeType-{{listItem.id}}"
                          nbcMismatch="input-xs"
                          placeHolderValue="-1"
                          placeHolderDisplay="-Select-"
                          [customErrorClass]="mandatoryConfig.employeeType ? 'required-outline':''"
                          authenticate-user="Timecard.EmployeeType.Update"
                          authenticate-command="nbcdisabled"
                          [nbcDisabled]="!listItem.businessValidation.isFieldEnabled|| listItem.parentTimecard"
                          (modelChange)="onEmployeeTypeChange($index,$event);onBlurDatavalidation($index)"></nbc-select>
            </div>
          </div>
          <!--SCOR-15980 Ends-->
          <div class="grid-col grid-col-scroll operation-field"
               [class.d-none]="!uiDeptSettings.isOperationDeptExpanded">
            <div id="stateContactWorked-validationmsg-{{listItem.id}}" class="required-msg d-none">Required</div>
            <div class=" grid-itm workState-list clearfix">

              <nbc-select [source]="workStates"
                          [(model)]="listItem.stateContactWorked"
                          [title]="listItem.stateContactWorked?.description ? listItem.stateContactWorked.description:''"
                          display="description"
                          nbcMismatch="input-xs"
                          value="id"
                          name="stateContactWorked-{{listItem.id}}"
                          id="stateContactWorked-{{listItem.id}}"
                          placeHolderValue="-1"
                          placeHolderDisplay="-Select-"
                          [nbcDisabled]="!listItem.businessValidation.isWorkStateValidation || listItem.parentTimecard"
                          [customErrorClass]="listItem.businessValidation.isWorkStateValidation ? 'required-outline':''"
                          authenticate-user="Timecard.EmployeeType.Update"
                          authenticate-command="nbcdisabled"
                          (modelChange)="onWorkStateChange($event,$index,'stateContactWorked');onBlurDatavalidation($index)"></nbc-select>

            </div>
          </div>
          <div class="grid-col operation-field"
               [class.d-none]="!uiDeptSettings.isOperationDeptExpanded">
            <div id="customRate-validationmsg-{{listItem.id}}" class="required-msg d-none">Required</div>
            <div class=" grid-itm payroll-custom-rate ">
              <div class=" input-group-text float-start">$</div>
              <div class="float-start">
                <input type="text"
                       authenticate-user="Timecard.Rate.Update"
                       authenticate-command="disabled"
                       appInputRestriction="decimalOnly"
                       placeholder="---.--"
                       data-field="customRate"
                       id="customRate-{{listItem.id}}"
                       [attr.title]="listItem.customRate ? listItem.customRate:null"
                       [(ngModel)]="listItem.customRate"
                       name="customRate-{{listItem.id}}"
                       [class.highlight]="(listItem.customRate && listItem.customRate > this.rateLimit) || null"
                       maxlength="9"
                       decimals="5"
                       class="form-control custom-rate-el text-font numbers-only"
                       [ngClass]="mandatoryConfig.customRate && listItem.businessValidation.isRateValid ? 'required-outline':''"
                       (ngModelChange)="onCustomRateChange($index)"
                       (blur)="customFormat($index)"
                       [authenticate-disabled]="(!listItem.businessValidation.isFieldEnabled || !!listItem.parentTimecard || (buAccess.department === 'FINANCE' || buAccess.department === 'PAYROLL'))||null" />
              </div>
            </div>
          </div>
          <div class="grid-col hours-worked operation-field"
               [class.d-none]="!uiDeptSettings.isOperationDeptExpanded">
            <div class=" grid-itm">
              <input type="text"
                     authenticate-user="Timecard.HoursWorked.Update"
                     authenticate-command="disabled"
                     appInputRestriction="numberOnly"
                     class="form-control hours-worked hours-worked-el  text-font numbers-only restrict-characters"
                     data-field="hoursWorked"
                     [attr.title]="listItem.hoursWorked ? listItem.hoursWorked:null"
                     [(ngModel)]="listItem.hoursWorked"
                     name="hoursWorked-{{listItem.id}}"
                     id="hoursWorked-{{listItem.id}}"
                     nbc-decimal
                     maxlength="2"
                     decimals="3"
                     (ngModelChange)="onHoursWorkedChange($index,$event)"
                     [authenticate-disabled]="(!listItem.businessValidation.isFieldEnabled || !!listItem.parentTimecard || (buAccess.department === 'FINANCE' || buAccess.department === 'PAYROLL'))||null" />
            </div>
          </div>
          <div class="grid-col grid-col-scroll company-code operation-field"
               [class.d-none]="!uiDeptSettings.isOperationDeptExpanded">
            <div class=" grid-itm">
              <nbc-select [source]="companyCodes"
                          nbcMismatch="input-xs"
                          [(model)]="listItem.companyCode"
                          [title]="listItem.companyCode?listItem.companyCode.description:null"
                          display="description"
                          value="description"
                          name="companyCode-{{listItem.id}}"
                          id="companyCode-{{listItem.id}}"
                          placeHolderValue="-Select-"
                          placeHolderDisplay="-Select-"
                          [nbcDisabled]="!listItem.businessValidation.isFieldEnabled || !!listItem.parentTimecard"
                          authenticate-user="Timecard.CompanyCode.Update"
                          authenticate-command="nbcdisabled"
                          (modelChange)="onCompanyCodeChange($event,$index,'companyCode')"></nbc-select>
              <!--<select class="dropdown-toggle form-control"
            name="companyCode-{{listItem.id}}"
            [(ngModel)]='listItem.companyCode'
            [disabled]="!listItem.businessValidation.isFieldEnabled || !!listItem.parentTimecard"
            (change)="onCompanyCodeChange($event.target.value,$index,'companyCode')"
            data-authenticate-user="Timecard.CompanyCode.Update"
            data-authenticate-command="disabled">
      <option selected value="-1">-Select-</option>
      <option *ngFor="let data of companyCodes" [value]="data.description">
        {{data.description}}
      </option>
                </select>-->
            </div>
          </div>
          <div class="grid-col operation-field"
               [class.d-none]="!uiDeptSettings.isOperationDeptExpanded">

            <div class="grid-itm cost-center text-center">
              <div class="cost-center-selection">
                <div class="text-center">
                  <input type="radio"
                         class="cost-center-el"
                         data-field="isWbse"
                         authenticate-user="Timecard.WBSECostCenter.Update"
                         authenticate-command="disabled"
                         id="costCenterType-wbse-{{listItem.id}}"
                         name="costCenterType-{{listItem.id}}"
                         value=""
                         [checked]="listItem.wbse || (!listItem.wbse && !listItem.costCenter) ? 'checked':null"
                         (change)="onCostCenterChange($index,'isWbse')"
                         [authenticate-disabled]="!listItem.businessValidation.isFieldEnabled || null"/>
                </div>
                <div class="text-center"
                     style="padding:3px">
                  WBSE
                </div>
                <div>
                  <input type="radio"
                         data-id="{{listItem.id}}"
                         style="padding:1px"
                         class="cost-center-el"
                         data-field="isCostCenter"
                         authenticate-user="Timecard.WBSECostCenter.Update"
                         authenticate-command="disabled"
                         id="costCenterType-costCenter-{{listItem.id}}"
                         name="costCenterType-{{listItem.id}}"
                         [checked]="listItem.costCenter ?'checked':null"
                         (change)="onCostCenterChange($index,'isCostCenter')"
                         [authenticate-disabled]="!listItem.businessValidation.isFieldEnabled || null"/>
                </div>
                <div style="padding:3px">
                  CC
                </div>
              </div>

              <div class="cost-center-input"
                   [attr.style]="(listItem.isCostCenter)?'display:none':''">
                <div id="wbse-validationmsg-{{listItem.id}}" class="required-msg d-none">Required</div>
                <input type="text"
                       class="wbse-input-el wbse-copy-paste-only"
                       [ngClass]="mandatoryConfig.wbse && listItem.businessValidation.isWBSEValid ? 'required-outline':''"
                       style="float:left"
                       data-field="wbse"
                       authenticate-user="Timecard.WBSECostCenter.Update"
                       authenticate-command="disabled"
                       [attr.title]="listItem.wbse ? listItem.wbse:null"
                       [(ngModel)]="listItem.wbse"
                       name="wbse-{{listItem.id}}"
                       id="wbse-{{listItem.id}}"
                       (change)="onWbseCopyPasteOnly($index,$event)"
                       [authenticate-disabled]="!listItem.businessValidation.isFieldEnabled || null"/>
                <button authenticate-user="Timecard.WBSECostCenter.Update"
                        authenticate-command="disabled"
                        (click)="selectWBSEModal(listItem.id)"
                        class="btn btn-primary btncls wbse-el"
                        style="margin:0 !important;text-align:center"
                        [authenticate-disabled]="!listItem.businessValidation.isFieldEnabled || null">
                  <i class="fa fa-search"></i>
                </button>
              </div>

              <div class="cost-center-input"
                   [attr.style]="!listItem.isCostCenter?'display:none':''">
                <div id="costCenter-validationmsg-{{listItem.id}}" class="required-msg d-none">Required</div>
                <input type="text"
                       id="costCenter-{{listItem.id}}"
                       [attr.title]="listItem.costCenter ? listItem.costCenter:null"
                       data-field="costCenter"
                       [(ngModel)]="listItem.costCenter"
                       name="costCenter-{{listItem.id}}"
                       [ngClass]="mandatoryConfig.wbse && listItem.businessValidation.isWBSEValid?'required-outline':''"
                       class="cost-center-input-el"
                       (ngModelChange)="onCostCenterInputChange($index,$event)"
                       [disabled]="!listItem.businessValidation.isFieldEnabled"/>
              </div>

            </div>
          </div>
          <div class="grid-col grid-col-scroll grid-col-120 operation-field"
               [class.d-none]="!uiDeptSettings.isOperationDeptExpanded">
            <div class="grid-itm">
              <div id="glAccount-validationmsg-{{listItem.id}}" class="required-msg d-none">Required</div>
              <span class="payroll-glaccount">
                <glaccount name="glAccount_{{listItem.id}}"
                           id="glAccount-{{listItem.id}}"
                           placeHolder="GL Account"
                           [isRequired]="mandatoryConfig?.glAccount && listItem.businessValidation.isGLAccountRequired"
                           [nbcClass]="mandatoryConfig?.glAccount && listItem.businessValidation.isGLAccountRequired?'required-outline':''"
                           [(model)]="listItem.glAccount"
                           title="{{listItem.glAccount}}"
                           [nbcDisabled]="!listItem.businessValidation.isFieldEnabled || listItem.parentTimecard"
                           [typeaheadOptionLimit]="10"
                           nbcAuthenticateUser="Timecard.GLAccount.Update"
                           nbcAuthenticateCommand="disabled"
                           nbcAuthenticateDisabled="expired"
                           (glAccountChange)="onGlAccountSelected($event,$index)">
                </glaccount>
              </span>

            </div>
          </div>

          <div class="grid-col grid-col-scroll operation-field"
               [class.d-none]="!uiDeptSettings.isOperationDeptExpanded">
            <div class="grid-itm operation-comments">
              <textarea class="payroll-notes form-control operations-grid-comments restrict-specialcharacters ays-ignore comments-change-el"
                        maxlength="255"
                        data-dept-key="SUBMITTER"
                        data-field="operationDeptComments"
                        authenticate-user="Timecard.OperationComment.Update"
                        appInputRestriction="noSpecialChars"
                        authenticate-command="disabled"
                        name="operationsComments-{{listItem.id}}"
                        id="operationsComments-{{listItem.id}}"
                        [(ngModel)]="listItem.operationDeptComments"
                        [attr.title]="listItem.operationDeptComments?listItem.operationDeptComments:null"
                        aria-invalid="false"
                        (change)="onInputChange($index,'operationDeptComments','SUBMITTER')"
                        [authenticate-disabled]="(!listItem.businessValidation.isFieldEnabled || buAccess.department!=='SUBMITTER'  || !!listItem.parentTimecard) || null"> 
            </textarea>
            </div>
          </div>
          <div class="grid-col grid-col-scroll operation-field"
               [class.d-none]="(!uiDeptSettings.isOperationDeptExpanded || buAccess.department !== 'SUBMITTER')"
               [ngClass]="buAccess.department!=='SUBMITTER'?'d-none':''">

            <div data-dept-key="SUBMITTER" class=" grid-itm operation-actions">
              <label class="timecard-action-button btn-department-submit btn"
                    [class.d-none]="listItem.parentTimecard"
                    authenticate-user="Timecard.Submitter.Submit.Retrieve"
                    authenticate-command="disabledlabel"
                    [class.grid-activebtn]="listItem.businessValidation.canSubmitOperation && !listItem.businessValidation.isFutureActivity"
                    title="Submit"
                    name="Submit-{{listItem.id}}"
                    (click)="onDepartmentSubmit($index,listItem.id,'SUBMITTER')"
                    [authenticate-disabled]="(!listItem.businessValidation.canSubmitOperation || listItem.businessValidation.isFutureActivity) || null">
                      <i class="fa fa-paper-plane" aria-hidden="true"></i>
              </label>
              <label class="timecard-action-button btn-timecard-save btn"
                    [class.d-none]="listItem.parentTimecard"
                    [class.grid-activebtn]="listItem.businessValidation.canTcSaveOperation"
                    authenticate-user="Timecard.Submitter.Save.Retrieve"
                    authenticate-command="disabledlabel"
                    title="Save"
                    name="Save-{{listItem.id}}"
                    (click)="onTimecardSave($index,listItem.id,'SUBMITTER')"
                    [authenticate-disabled]="!listItem.businessValidation.canTcSaveOperation || null">
                      <i class="fa fa-floppy-o" aria-hidden="true"></i>
              </label>


            </div>
          </div>
        </ng-container>
      </ng-container>


      <ng-container *ngIf="buAccess.department !== 'SUBMITTER'">
        <div [class.d-none]="uiDeptSettings.isTalentDeptExpanded || !hasTalentDepartment"
             class="grid-col grid-col-emp-type talnt-dept-collapse talnt-collapsed-bar">
          <div class=" grid-itm">

          </div>
        </div>
        <ng-container *ngIf="uiDeptSettings.hasApproverAccess">
          <div [class.d-none]="!uiDeptSettings.isTalentDeptExpanded || !hasTalentDepartment"
               class="grid-col grid-col-scroll talent-field">
            <div class="grid-itm talent-comments">
              <textarea class="payroll-notes form-control talent-grid-comments ays-ignore comments-change-el"
                        maxlength="255"
                        appInputRestriction="restrictChars"
                        authenticate-user="Timecard.TalentComment.Update"
                        authenticate-command="disabled"
                        name="talentComments-{{listItem.id}}"
                        id="talentComments-{{listItem.id}}"
                        [(ngModel)]="listItem.talentComments"
                        aria-invalid="false"
                        [authenticate-disabled]="(!listItem.businessValidation.isFieldEnabled ||  buAccess.department!=='APPROVER'|| !!listItem.parentTimecard) || null"
                        (change)="onInputChange($index,'talentComments','APPROVER')">
            </textarea>

            </div>
          </div>
          <div [class.d-none]="(!uiDeptSettings.isTalentDeptExpanded ||buAccess.department !== 'APPROVER' || !hasTalentDepartment)"
               class="grid-col grid-col-scroll talent-field"
               [ngClass]="buAccess.department !== 'APPROVER'?'d-none':''">
            <div class=" grid-itm talent-actions align-center"
                 data-dept-key="APPROVER">
              <label class="timecard-action-button btn btn-department-submit"
                    [class.d-none]="listItem.parentTimecard"
                    [class.grid-activebtn]="listItem.businessValidation.canSubmitTalent && !listItem.businessValidation.isFutureActivity"
                    title="Submit"
                    name="Submit-{{listItem.id}}"
                    [class.disabled]="(!listItem.businessValidation.canSubmitTalent || listItem.businessValidation.isFutureActivity) || null"
                    (click)="onDepartmentSubmit($index,listItem.id,'APPROVER')">
                      <i class="fa fa-paper-plane" aria-hidden="true"></i>
              </label>
              <label class="timecard-action-button btn-timecard-save btn"
                    authenticate-user="Timecard.Approver.Save.Retrieve"
                    authenticate-command="disabledlabel"
                    title="Save"
                    [class.grid-activebtn]="listItem.businessValidation.canTcSaveTalent"
                    [class.d-none]="listItem.parentTimecard"
                    name="Save-{{listItem.id}}"
                    (click)="onTimecardSave($index,listItem.id,'APPROVER')"
                    [authenticate-disabled]="!listItem.businessValidation.canTcSaveTalent || null">
                      <i class="fa fa-floppy-o" aria-hidden="true"></i>
              </label>
              <label class="timecard-action-button btn btn-department-reject"
                    [class.d-none]="listItem.parentTimecard"
                    [class.reject-popover]="listItem.businessValidation.canApproverReject"
                    [class.disabled]="!listItem.businessValidation.canApproverReject || null"
                    [popover]="popoverApprover_RejectCard"
                    #popApprover="bs-popover"
                    placement="left"
                    popoverClass="rejectpopover">
                <img src="../../../../../Content/app/images/TalentPayroll/reject_btn.png"
                     class="rejectbtn"
                     name="reject-{{listItem.id}}" title="Reject"
                     [class.disabled]="!listItem.businessValidation.canApproverReject || null" />
                <ng-template #popoverApprover_RejectCard  style="padding:0px;margin:0px;border:none">
                  <span reject-timecard-popover
                        style="border:0px;margin:0px;"
                        [listItem]="listItem"
                        [previousDepts]="listItem.dept"
                        [user]="user"
                        [rejectingDept]="APPROVER"
                        (onClosePopover)="popApprover.hide()">
                  </span>
                </ng-template>
              </label>
            </div>
          </div>
        </ng-container>

        <div [class.d-none]="uiDeptSettings.isFinanceDeptExpanded"
             class="grid-col grid-col-emp-type fin-collapsed-bar">
          <div class=" grid-itm">

          </div>
        </div>
        <ng-container *ngIf="uiDeptSettings.hasFinanceAccess">
          <div [class.d-none]="!uiDeptSettings.isFinanceDeptExpanded"
               class="grid-col finance-aftra-custom-percentage finDept-field">
            <div class=" grid-itm">
              <span>
                <input type="text"
                       class="aftra-percentage-el"
                       data-field="aftraPercentage"
                       authenticate-user="Timecard.AFtraPercentage.Update"
                       authenticate-command="disabled"
                       appInputRestriction="numberOnly"
                       maxlength="3"
                       [(ngModel)]="listItem.aftraPercentage"
                       name="aftraPercentage-{{listItem.id}}"
                       [authenticate-disabled]="(!listItem.businessValidation.isFieldEnabled || !!listItem.parentTimecard || !listItem.businessValidation.isFinanceFieldEnabled) || null"
                       (blur)="onAftraPercentageChanged($index,$event)"
                       (input)="onAftraPercentageTyped($index,$event)" />
              </span>
              <span *ngIf="!listItem.parentTimecard">
                <img src="/Content/app/images/icon-tpm-split.png"
                     class="timecard-aftra-button btn btn-aftra-split"
                     [ngClass]="{'d-none': listItem.isAftraPayment=== 'Y'   || listItem.aftraPercentage<=0 || listItem.aftraPercentage>99,'disabled': buAccess.department === 'PAYROLL' || listItem.queueStatus === 'POSTQUEUE'}"
                     title="Split Payment"
                     data-field="aftraSplit"
                     name="aftraSplit-{{listItem.id}}"
                     (click)="onAftraSplit(listItem.id)"/>

                <img src="/Content/app/images/icon-tpm-merge.png" class="timecard-aftra-button-merge btn btn-aftra-merge"
                     [ngClass]="{'d-none': listItem.isAftraPayment!=='Y','disabled': buAccess.department === 'PAYROLL' || listItem.queueStatus === 'POSTQUEUE'}"
                     title="Merge Payments"
                     data-field="aftraMerge"
                     id="aftraMerge-{{listItem.id}}"
                     name="aftraMerge-{{listItem.id}}"
                     (click)="onAftraMerge(listItem.id)" />
              </span>
            </div>
          </div>
          <div [class.d-none]="!uiDeptSettings.isFinanceDeptExpanded"
               class="grid-col finance-aftra-custom-amount finDept-field">
            <div class="grid-itm">
              <input type="text"
                     [attr.title]="listItem.aftraAmount?listItem.aftraAmount:null"
                     data-property-name="aftraAmount"
                     class="form-control aftra-amount-el text-font"
                     data-field="aftraAmount"
                     authenticate-user="Timecard.AFtraAmount.Retrieve"
                     authenticate-command="disabled"
                     name="aftraAmount-{{listItem.id}}"
                     [(ngModel)]="listItem.aftraAmount"
                     disabled="disabled"
                     (blur)="onAftraAmountChanged($index,$event)" />
            </div>
          </div>
          <div [class.d-none]="!uiDeptSettings.isFinanceDeptExpanded"
               class="grid-col grid-col-scroll finDept-field">
            <div class="grid-itm">
              <nbc-select [source]="unionCodes"
                          [(model)]="listItem.unionCode"
                          [title]="listItem.unionCode?listItem.unionCode.description:null"
                          display="description"
                          value="id"
                          name="unionCode-{{listItem.id}}"
                          placeHolderValue="-1"
                          placeHolderDisplay="-Select-"
                          authenticate-user="Timecard.UnionCode.Update"
                          authenticate-command="nbcselectdisabled"                          
                          [authenticate-disabled]="!listItem.businessValidation.isFieldEnabled || !listItem.businessValidation.isFinanceFieldEnabled || (buAccess.department!=='FINANCE' && listItem.parentTimecard)"
                          (modelChange)="onUnionCodeChanged($index,'unionCode')"></nbc-select>
            </div>
          </div>
          <div [class.d-none]="!uiDeptSettings.isFinanceDeptExpanded"
               class="grid-col grid-col-scroll finDept-field">
            <div class="grid-itm finance-comments">
              <textarea class="payroll-notes form-control finance-grid-comments restrict-specialcharacters ays-ignore comments-change-el"
                        maxlength="255"
                        data-dept-key="FINANCE"
                        data-property-name="financeComments"
                        data-field="financeComments"
                        appInputRestriction="noSpecialChars"
                        authenticate-user="Timecard.FinanceComment.Update"
                        authenticate-command="disabled"
                        name="financeComments-{{listItem.id}}"
                        id="financeComments-{{listItem.id}}"
                        [(ngModel)]="listItem.financeDeptComments"
                        aria-invalid="false"
                        [authenticate-disabled]="(!listItem.businessValidation.isFieldEnabled ||  buAccess.department!=='FINANCE' || !!listItem.parentTimecard || !listItem.businessValidation.isFinanceFieldEnabled) || null"
                        (change)="onInputChange($index,'financeDeptComments','FINANCE')">
            </textarea>
            </div>
          </div>
          <div [class.d-none]="(!uiDeptSettings.isFinanceDeptExpanded|| buAccess.department !== 'FINANCE')"
               class="grid-col grid-col-scroll finDept-field"
               [ngClass]="buAccess.department !== 'FINANCE'?'d-none':''">
            <div class="grid-itm" data-dept-key="FINANCE">
              <label class="timecard-action-button btn btn btn-department-submit"
                     authenticate-user="Timecard.Finance.Submit.Retrieve"
                     authenticate-command="disabledlabel"
                     [class.d-none]="listItem.parentTimecard"
                     [class.grid-activebtn]="listItem.businessValidation.canSubmitFinance && !listItem.businessValidation.isFutureActivity"
                     title="Submit"
                     name="Submit-{{listItem.id}}"
                     (click)="onDepartmentSubmit($index,listItem.id,'FINANCE')"
                     [authenticate-disabled]="(!listItem.businessValidation.canSubmitFinance || listItem.businessValidation.isFutureActivity) || null">
                <i class="fa fa-paper-plane" aria-hidden="true"></i>
              </label>
              <label class="timecard-action-button btn-timecard-save btn"
                     [class.d-none]="listItem.parentTimecard"
                     [class.grid-activebtn]="listItem.businessValidation.canTcSaveFinance"
                     authenticate-user="Timecard.Finance.Save.Retrieve"
                     authenticate-command="disabledlabel"
                     title="Save"
                     name="Save-{{listItem.id}}"
                     [authenticate-disabled]="!listItem.businessValidation.canTcSaveFinance || null"
                     (click)="onTimecardSave($index,listItem.id,'FINANCE')">
                <i class="fa fa-floppy-o" aria-hidden="true"></i>
              </label>
              <label class="timecard-action-button btn btn-department-reject"
                     [class.reject-popover]="listItem.businessValidation.canFinanceReject"
                     [class.d-none]="listItem.parentTimecard"
                     authenticate-user="Timecard.Finance.Reject.Retrieve"
                     authenticate-command="disabledlabel"
                     [popover]="popoverFinance_RejectCard"
                     #popFinance="bs-popover"
                     placement="left"
                     popoverClass="rejectpopover"
                     [authenticate-disabled]="!listItem.businessValidation.canFinanceReject || null">
                <img src="../../../../../Content/app/images/TalentPayroll/reject_btn.png"
                     class="rejectbtn"
                     name="reject-{{listItem.id}}" title="Reject"
                     [disabled]="!listItem.businessValidation.canFinanceReject" />
                <ng-template #popoverFinance_RejectCard style="padding:0px;margin:0px;border:none">
                  <span reject-timecard-popover
                        style="border:0px;margin:0px;"
                        [listItem]="listItem"
                        [previousDepts]="listItem.dept"
                        [user]="user"
                        [rejectingDept]="FINANCE"
                        (onClosePopover)="popFinance.hide()">
                  </span>
                </ng-template>
              </label>
            </div>
          </div>
        </ng-container>


        <div [class.d-none]="uiDeptSettings.isPayrollDeptExpanded"
             class="grid-col grid-col-emp-type payDept-collapsed-bar">
          <div class=" grid-itm">

          </div>
        </div>

        <ng-container *ngIf="uiDeptSettings.hasPayrollAccess">
          <div [class.d-none]="!uiDeptSettings.isPayrollDeptExpanded || uiDeptSettings.isOperationDeptExpanded"
               class="grid-col payrollDept-field activity-date hideOnOperationExpand">
            <div class=" grid-itm">
              <div class="input-group activity-datetimepicker">
                <input type="text"
                       disabled="disabled"
                       bsDatepicker
                       data-field="activityDate"
                       [attr.title]="listItem.activityDate?listItem.activityDate:null"
                       name="activityDate-{{listItem.id}}"
                       class="form-control activity-date-focus filter-activityDate"
                       [bsConfig]="{ isAnimated: true, dateInputFormat: 'MM/DD/YYYY' , customTodayClass:'custom-today-class'}"
                       [(ngModel)]="listItem.activityDate" />

                <!--<span class="input-group-addon">
          <span class="glyphicon glyphicon-calendar"></span>
        </span>-->
                <span class="input-group-text">
                  <!--<span class="glyphicon glyphicon-calendar"></span>-->
                  <!--SCOR-22127-->
                  <button class="fa fa-calendar"
                          style="border: none;background: white;"
                          type="button">
                  </button>
                </span>
              </div>
            </div>
          </div>
          <div [class.d-none]="!uiDeptSettings.isPayrollDeptExpanded || uiDeptSettings.isOperationDeptExpanded"
               class="grid-col payrollDept-field hideOnOperationExpand" [ngStyle]="{'background-color': listItem.isRateDayHigh ? 'lightblue' : listItem.highlightRateCell ? '#f6e97d' : ''}">
            <div class=" grid-itm payroll-custom-rate ">
              <div class=" input-group-text float-start">$</div>
              <div class="float-start">
                <input type="text"
                       placeholder="---.--"
                       data-field="customRate"
                       [(ngModel)]="listItem.customRate"
                       [attr.title]="listItem.customRate?listItem.customRate:null"
                       name="payroll-customRate-{{listItem.id}} "
                       disabled="disabled"
                       class="form-control text-font payroll-custom-rate-el"
                       [ngClass]="listItem.aftraAmount? 'd-none':''" />

                <input type="text"
                       data-property-name="aftraAmount"
                       class="form-control text-font"
                       [ngClass]="!listItem.aftraAmount? 'd-none':''"
                       data-field="aftraAmount"
                       name="payroll-aftraAmount-{{listItem.id}}"
                       [attr.title]="listItem.aftraAmount?listItem.aftraAmount:null"
                       [(ngModel)]="listItem.aftraAmount"
                       disabled="disabled" />

              </div>
            </div>
          </div>
          <div [class.d-none]="!uiDeptSettings.isPayrollDeptExpanded  || uiDeptSettings.isOperationDeptExpanded"
               class="grid-col hours-worked payrollDept-field hideOnOperationExpand">
            <div class=" grid-itm">
              <input type="text"
                     class="form-control text-font hours-worked hours-worked-el"
                     data-field="hoursWorked"
                     [attr.title]="listItem.hoursWorked?listItem.hoursWorked:null"
                     [(ngModel)]="listItem.hoursWorked"
                     name="hoursWorked"
                     disabled="disabled" />
            </div>
          </div>
          <div [class.d-none]="!uiDeptSettings.isPayrollDeptExpanded  || uiDeptSettings.isOperationDeptExpanded"
               class="grid-col payrollDept-field payroll-wbse-cc-readonly hideOnOperationExpand">
            <div class=" grid-itm">
              <div class="cost-center-input" id="wbse-{{listItem.id}}">
                <input type="text"
                       class="form-control text-font"
                       style="float:left"
                       [attr.title]="listItem.wbse? listItem.wbse : listItem.costCenter? listItem.costCenter:null"
                       [attr.value]="listItem.wbse? listItem.wbse : listItem.costCenter ? listItem.costCenter:null"
                       name="wbse"
                       disabled="disabled" />
              </div>
            </div>
          </div>
          <div [class.d-none]="!uiDeptSettings.isPayrollDeptExpanded || uiDeptSettings.isOperationDeptExpanded"
               class="grid-col grid-col-scroll grid-col-120 payrollDept-field hideOnOperationExpand">
            <div class=" grid-itm grid-employee-type">

              <nbc-select [source]="employeeTypes"
                          [(model)]="listItem.employeeType"
                          [title]="listItem.employeeType?.description ? listItem.employeeType.description:''"
                          display="description"
                          value="id"
                          nbcMismatch="input-xs"
                          name="employeeType-{{listItem.id}}"
                          placeHolderValue="-1"
                          placeHolderDisplay="-Select-"
                          [nbcDisabled]="true"></nbc-select>
            </div>
          </div>

          <div [class.d-none]="!uiDeptSettings.isPayrollDeptExpanded || uiDeptSettings.isOperationDeptExpanded"
               class="grid-col grid-col-scroll grid-col-120 payrollDept-field hideOnOperationExpand">
            <div class="grid-itm">
              <span class="payroll-glaccount">
                <input type="text"
                       [attr.value]="listItem.glAccount?listItem.glAccount:null"
                       data-field="glAccount"
                       authenticate-user="Timecard.GLAccount.Update"
                       authenticate-command="disabled"
                       data-property-name="glAccount"
                       [attr.title]="listItem.glAccount?listItem.glAccount:null"
                       class="form-control text-font gl-account-typeahead input-number"
                       required maxlength="10"
                       disabled="disabled"
                       name="glAccount-{{listItem.id}}"
                       id="glAccount-{{listItem.id}}" />
              </span>

            </div>
          </div>
          <div [class.d-none]="!uiDeptSettings.isPayrollDeptExpanded"
               class="grid-col grid-col-scroll payroll-wage-type payrollDept-field">
            <div id="wageType-validationmsg-{{listItem.id}}" class="required-msg d-none">Required</div>
            <div class="grid-itm">
              <input type="text"
                     maxlength="4"
                     data-field="wageType"
                     authenticate-user="Timecard.WageType.Update"
                     authenticate-command="disabled"
                     id="wageType-{{listItem.id}}"
                     name="wageType-{{listItem.id}}"
                     data-property-name="wageType"
                     [(ngModel)]="listItem.wageType"
                     [authenticate-disabled]="(!listItem.businessValidation.isFieldEnabled || !!listItem.parentTimecard)  || null "
                     class="form-control text-font wage-type-el "
                     [ngClass]="listItem.businessValidation.isWageTypeRequired && buAccess.department === 'PAYROLL'? 'required-outline':''"
                     (ngModelChange)="onWageTypeChange($index,$event)" />
            </div>
          </div>
          <div [class.d-none]="!uiDeptSettings.isPayrollDeptExpanded"
               class="grid-col grid-col-scroll grid-col-120 payrollDept-field payroll-pay-transactions">
            <div id="payrollProvider-validationmsg-{{listItem.id}}" class="required-msg d-none">Required</div>
            <div class=" grid-itm">
              <nbc-select [source]="payrollProviders"
                          [(model)]="listItem.payrollProvider"
                          [title]="listItem.payrollProvider?.description?listItem.payrollProvider.description:null"
                          display="description"
                          nbcMismatch="input-xs"
                          value="id"
                          name="payrollProvider-{{listItem.id}}"
                          id="payrollProvider-{{listItem.id}}"
                          placeHolderValue="-1"
                          placeHolderDisplay="-Select-"
                          [nbcDisabled]="!listItem.businessValidation.isFieldEnabled || listItem.parentTimecard"
                          [customErrorClass]="mandatoryConfig.payrollProvider ?'required-outline':''"
                          authenticate-user="Timecard.PayrollProvider.Update"
                          authenticate-command="nbcdisabled"
                          (modelChange)="onPayrollProviderChange($index,$event);onBlurDatavalidation($index)"></nbc-select>
            </div>
          </div>
          <div [class.d-none]="!uiDeptSettings.isPayrollDeptExpanded"
               class="grid-col grid-col-scroll grid-col-200 payrollDept-field">
            <div id="contractCode-validationmsg-{{listItem.id}}" class="required-msg d-none">Required</div>
            <div class="grid-itm">
              <nbc-select [source]="contractCodes"
                          [model]="listItem.contractCode"
                          [title]="listItem.contractCode?.name?listItem.contractCode?.name:null"
                          display="name"
                          nbcMismatch="input-xs"
                          value="id"
                          name="contractCode-{{listItem.id}}"
                          id="contractCode-{{listItem.id}}"
                          placeHolderValue="-1"
                          placeHolderDisplay="-Select-"
                          [nbcDisabled]="!listItem.businessValidation.isFieldEnabled || listItem.payrollProvider?.id!=='TK' || listItem.parentTimecard"
                          [customErrorClass]="mandatoryConfig.contractCode && listItem.payrollProvider?.id =='TK'?'required-outline':''"
                          authenticate-user="Timecard.TKContractCode.Update"
                          authenticate-command="nbcdisabled"
                          [attachOldValue]="true"
                          (modelChange)="onContractCodeChange(listItem.id,$event);onBlurDatavalidation($index)"></nbc-select>
            </div>
          </div>
          <div [class.d-none]="!uiDeptSettings.isPayrollDeptExpanded"
               class="grid-col grid-col-scroll payroll-pay-transactions payrollDept-field">
            <div class="grid-itm">
              <div id="payTransactions-validationmsg-{{listItem.id}}" class="required-msg d-none add-transactions">Required</div>
              <div name="payTransactions-{{listItem.id}}" class="add-transactions">
                <span class="payroll-add-transactions add-transactions"
                      [ngClass]="listItem.payTransactions?.length > 0? 'd-none':''"
                      name="payrolladdtransactions-{{listItem.id}}"
                      id="payrolladdtransactions-{{listItem.id}}"
                      (click)="addPayTransaction(listItem.id)">
                  <button class="btn tk-provider-field-el-{{listItem.id}} btn-primary paytransaction-btncls text-nowrap"
                          name="btnpayrolltransactions-{{listItem.id}}"
                          [authenticate-disabled]="(listItem.payrollProvider?.id!=='TK' || !listItem.contractCode?.name || !listItem.businessValidation.isFieldEnabled) || null"
                          authenticate-user="Timecard.PayTransaction.Update"
                          authenticate-command="disabled">
                    ADD PAY TRANSACTION
                  </button>
                  <input type="hidden"
                         [attr.value]="listItem.payTransactions && listItem.payTransactions?.length > 0 ? true:false"
                         class="hidden-pay-transaction" name="payTransaction-{{listItem.id}}" id="payTransaction-{{listItem.id}}" />
                </span>
              </div>
              <span *ngIf="listItem.payTransactions?.length > 0"
                    class="payroll-edit-transactions edit-transactions">
                <a class="transaction-count">
                  <span [popover]="popPayTransationTemplate"
                        popoverTitle="Pay Transactions"
                        triggers="mouseenter:mouseleave"
                        popoverContext="listItem"
                        popoverClass="payTransactionpopover"
                        [outsideClick]="false"
                        class="float-start" style="margin-left: 40px;width:auto;">
                    {{listItem.payTransactions?.length}} transaction<ng-container *ngIf="listItem.payTransactions?.length > 1">s</ng-container>
                  </span>
                  <ng-template #popPayTransationTemplate>
                    <div *ngIf="listItem.payTransactions.length >= 1">
                      <div style="padding:10px;margin:10px;width:200px" *ngFor="let transaction of listItem.payTransactions;index as index;">
                        {{transaction.transactionType.description}} / {{transaction.hrUnit}} / {{transaction.rate}}
                      </div>
                    </div>
                  </ng-template>
                  <i class="fa fa-pencil float-start cursor-pointer" style="margin-left: 5px; margin-top: 1px;" (click)="addPayTransaction(listItem.id)"></i>
                </a>

              </span>
              <input type="hidden" name="transaction-dirty-{{listItem.id}}" class="transaction-dirty" value="" />
            </div>
          </div>
          <div [class.d-none]="!uiDeptSettings.isPayrollDeptExpanded"
               class="grid-col grid-col-scroll payroll-wage-schedule payrollDept-field">
            <div id="wageschedule-validationmsg-{{listItem.id}}" class="required-msg d-none">Required</div>
            <div class="grid-itm">
              <input type="text"
                     maxlength="2"
                     appInputRestriction="numberOnly"
                     data-field="wageschedule"
                     authenticate-user="Timecard.Wageschedule.Update"
                     authenticate-command="disabled"
                     id="wageschedule-{{listItem.id}}"
                     name="wageschedule-{{listItem.id}}"
                     data-property-name="wageschedule"
                     [(ngModel)]="listItem.wageschedule"
                     [authenticate-disabled]="(!listItem.businessValidation.isFieldEnabled || !!listItem.parentTimecard)  || null "
                     class="form-control text-font wage-schedule-el "
                     [ngClass]="mandatoryConfig.wageschedule && listItem.payrollProvider?.id === 'SPB' && buAccess.department === 'PAYROLL' ? 'required-outline':''"
                     (ngModelChange)="onWagescheduleChange($index,$event)" />
            </div>
          </div>



          <div [class.d-none]="!uiDeptSettings.isPayrollDeptExpanded"
               class="grid-col grid-col-scroll payroll-job-code text-center payrollDept-field">
            <div id="jobCode-validationmsg-{{listItem.id}}" class="required-msg d-none">Required</div>
            <div class="grid-itm">
              <span class="payroll-job-code-1">
                <select field="jobCode"
                        name="jobCode-{{listItem.id}}"
                        id="jobCode-{{listItem.id}}"
                        [ngModel]="listItem.selectedJobCode"
                        (ngModelChange)=" onJobCodeChange($index,$event)"
                        data-property-name="jobCode"
                        [authenticate-disabled]="(!listItem.businessValidation.isFieldEnabled  || listItem.payrollProvider?.id!=='TK')|| null"
                        [ngClass]="listItem.payrollProvider?.id!=='TK'? 'required-outline':''"
                        class="form-select input-xs job-code-el"
                        authenticate-user="Timecard.JobCode.Update"
                        authenticate-command="disabled">
                  <option value="null">-Select-</option>
                  <option *ngFor="let jobCode of allJobCodes"
                          value="{{jobCode.code}}"
                          [attr.selected]="listItem.selectedJobCode === jobCode.code ? 'selected' :null">
                    {{jobCode.code}}
                  </option>
                </select>
              </span>

              <span class="payroll-job-code-2">
                <select field="jobCode"
                        name="jobCodeDetail-{{listItem.id}}"
                        id="jobCodeDetail-{{listItem.id}}"
                        class="form-select input-xs rate-code-el"
                        [ngModel]="listItem.rateCode"
                        (ngModelChange)=" onRateCodeChange($index,$event)"
                        [authenticate-disabled]="(!listItem.businessValidation.isFieldEnabled  || listItem.payrollProvider?.id!=='TK')|| null"
                        authenticate-user="Timecard.JobCode.Update"
                        authenticate-command="disabled">
                  <option *ngFor="let rate of listItem.jobCodeDetails"
                          value="{{rate.rateCode}}"
                          [attr.selected]="listItem.rateCode === rate.rateCode ? 'selected' :null">
                    {{rate.rateCode}}
                  </option>
                </select>
              </span>
            </div>
          </div>
          <div [class.d-none]="!uiDeptSettings.isPayrollDeptExpanded"
               class="grid-col timeCard-Rate payrollDept-field">
            <div class="grid-itm">
              <input type="text"
                     class="form-control text-font timeCard-Rate"
                     authenticate-user="Timecard.TimecardRate.Update"
                     authenticate-command="disabled"
                     nbc-decimal
                     maxlength="6"
                     decimals="3"
                     placeholder="---.--"
                     data-field="rate"
                     [(ngModel)]="listItem.rate"
                     [attr.value]="listItem.payrollProvider?.id ==='TK'? listItem.rate || 15.00 :null"
                     name="timeCardRate-{{listItem.id}}"
                     [authenticate-disabled]="(!listItem.businessValidation.isFieldEnabled  || listItem.payrollProvider?.id!=='TK') || null "
                     (ngModelChange)="onTimecardRateChange($index)" />
            </div>
          </div>

          <div [class.d-none]="!uiDeptSettings.isPayrollDeptExpanded"
               class="grid-col grid-col-scroll payrollDept-field">
            <div class="grid-itm payroll-comments">
              <textarea class="form-control payroll-grid-comments restrict-specialcharacters ays-ignore comments-change-el"
                        maxlength="255"
                        data-dept-key="PAYROLL"
                        data-field="payrollComments"
                        appInputRestriction="noSpecialChars"
                        authenticate-user="Timecard.PayrollComments.Update"
                        authenticate-command="disabled"
                        name="payrollNotes-{{listItem.id}}"
                        id="payrollNotes-{{listItem.id}}"
                        [(ngModel)]="listItem.payrollComment"
                        [authenticate-disabled]="(!listItem.businessValidation.isFieldEnabled ||  buAccess.department!=='PAYROLL' || !!listItem.parentTimecard) || null"
                        aria-invalid="false"
                        (change)="onInputChange($index,'payrollComment','PAYROLL')">
            </textarea>
            </div>
          </div>
          <div [class.d-none]="!uiDeptSettings.isPayrollDeptExpanded"
               class="grid-col grid-col-scroll payrollDept-field {{listItem.paymentStatusColor}}"
               [class.system-errors]="listItem.errorCode"
               [popover]="listItem.errorCode ?popover_systemError :null"
               popoverTitle="System Messages"
               container="body"
               triggers="mouseenter:mouseleave"
               popoverClass="rejectpopover"
               placement="left"
               [outsideClick]="false"
               title="{{listItem.paymentStatus}}" style="width:25px;">
            <div class="grid-itm" data-id="{{listItem.id}}">
              <label title="{{listItem.paymentStatus}}"></label>
            </div>
          </div>
          <ng-template #popover_systemError>
            <div class="popover-content validation-message">
              <ul class="list-unstyled">
                <li><b>Error Code :</b>{{listItem.errorCode}}</li>
                <li><b>Error Description :</b>{{listItem.errorDescription}}</li>
              </ul>
            </div>
          </ng-template>
          <div [class.d-none]="!uiDeptSettings.isPayrollDeptExpanded"
               class="grid-col grid-col-emp-type payrollDept-field"
               [ngClass]="buAccess.department !== 'PAYROLL'?'d-none':''">
            <div class="grid-itm" data-dept-key="PAYROLL">
              <label class="timecard-action-button btn btn btn-department-submit"
                     authenticate-user="Timecard.Payroll.Submit.Retrieve"
                     authenticate-command="disabledlabel"
                     [class.d-none]="listItem.parentTimecard || listItem.SPBStatusValidation.isSubmitted"
                     [class.grid-activebtn]="listItem.businessValidation.canSubmitPayroll && !listItem.businessValidation.isFutureActivity"
                     title="Submit"
                     name="Submit-{{listItem.id}}"
                     (click)="onDepartmentSubmit($index,listItem.id,'PAYROLL')"
                     [authenticate-disabled]="(!listItem.businessValidation.canSubmitPayroll || listItem.businessValidation.isFutureActivity) || null">
                <i class="fa fa-paper-plane" aria-hidden="true"></i>
              </label>
              <label class="timecard-action-button btn btn-timecard-save btn"
                     [class.d-none]="listItem.parentTimecard || listItem.SPBStatusValidation.isSubmitted"
                     [class.grid-activebtn]="listItem.businessValidation.canTcSavePayroll"
                     authenticate-user="Timecard.Payroll.Save.Retrieve"
                     authenticate-command="disabledlabel"
                     title="Save"
                     name="Save-{{listItem.id}}"
                     [authenticate-disabled]="!listItem.businessValidation.canTcSavePayroll || null"
                     (click)="onTimecardSave($index,listItem.id,'PAYROLL')">
                <i class="fa fa-floppy-o" aria-hidden="true"></i>
              </label>
              <label class="timecard-action-button btn btn-department-reject"
                     authenticate-user="Timecard.Payroll.Submit.Retrieve"
                     authenticate-command="disabledlabel"
                     style="padding:0px !important"
                     [class.d-none]="listItem.parentTimecard || listItem.SPBStatusValidation.isSubmitted"
                     [popover]="popover_PayrollRejectCard"
                     #popPayroll="bs-popover"
                     placement="left"
                     popoverClass="rejectpopover"
                     [class.reject-popover]="listItem.businessValidation.canPayrollReject"
                     [authenticate-disabled]="!listItem.businessValidation.canPayrollReject || null">
                <img src="../../../../../Content/app/images/TalentPayroll/reject_btn.png"
                     class="rejectbtn"
                     name="reject-{{listItem.id}}"
                     title="Reject"
                     [disabled]="!listItem.businessValidation.canPayrollReject" />
                <ng-template #popover_PayrollRejectCard style="padding:0px;margin:0px;border:none">
                  <span reject-timecard-popover
                        style="border:0px;margin:0px;"
                        [listItem]="listItem"
                        [previousDepts]="listItem.dept"
                        [user]="user"
                        [rejectingDept]="PAYROLL"
                        (onClosePopover)="popPayroll.hide()">
                  </span>
                </ng-template>
              </label>
              <input type="button" value="Un-Authorize" class="btn btn-reject"
                     [ngClass]="listItem.parentTimecard || !listItem.SPBStatusValidation.isUnAuthorized ? 'd-none':''" style="width:115px;"
                     authenticate-user="Timecard.SPB.UnAuthorize.Retrieve"
                     authenticate-command="disabled"
                     (click)="onUnauthorizedTimecard(listItem.id,'PAYROLL')" />
              <input type="button" value="Reject" class="btn btn-unassign"
                     [ngClass]="listItem.parentTimecard || !listItem.SPBStatusValidation.isRejected ? 'd-none':''" style="width:60px;"
                     authenticate-user="Timecard.SPB.Reject.Retrieve"
                     authenticate-command="disabled"
                     (click)="onRejectTimecard(listItem.id,'PAYROLL')" />
            </div>
          </div>

        </ng-container>
      </ng-container>
    </div>
  </ng-container>
</ng-template>
